import { defineMessages } from "react-intl";
export default defineMessages({
  temperature: {
    "id": "units.temperature",
    "defaultMessage": "Temperature"
  },
  dewPoint: {
    "id": "units.dewPoint",
    "defaultMessage": "Dew point"
  },
  frostPoint: {
    "id": "units.frostPoint",
    "defaultMessage": "Frost point"
  },
  feelLike: {
    "id": "units.feelLike",
    "defaultMessage": "Feels-like"
  },
  humidity: {
    "id": "units.humidity",
    "defaultMessage": "Humidity"
  },
  precipitation: {
    "id": "units.precipitation",
    "defaultMessage": "Precipitation"
  },
  rain: {
    "id": "units.rain",
    "defaultMessage": "Rain"
  },
  wind: {
    "id": "units.wind",
    "defaultMessage": "Wind"
  },
  windRun: {
    "id": "units.windRun",
    "defaultMessage": "Wind run"
  },
  windRunDescription: {
    "id": "units.windRunDescription",
    "defaultMessage": "The wind run is the total distance of the traveled wind over a period of time"
  },
  speed: {
    "id": "units.speed",
    "defaultMessage": "Speed"
  },
  windDirection: {
    "id": "units.windDirection",
    "defaultMessage": "Direction"
  },
  gust: {
    "id": "units.gust",
    "defaultMessage": "Gust"
  },
  pressure: {
    "id": "units.pressure",
    "defaultMessage": "Pressure"
  },
  relativePressure: {
    "id": "units.relativePressure",
    "defaultMessage": "Relative pressure"
  },
  absolutePressure: {
    "id": "units.absolutePressure",
    "defaultMessage": "Absolute pressure"
  },
  airDensity: {
    "id": "units.airDensity",
    "defaultMessage": "Air density"
  },
  millimeter: {
    "id": "units.millimeter",
    "defaultMessage": "Millimeter"
  },
  inch: {
    "id": "units.inch",
    "defaultMessage": "Inch"
  },
  kilometerPerHour: {
    "id": "units.kilometerPerHour",
    "defaultMessage": "Kilometers per hour"
  },
  milePerHour: {
    "id": "units.milePerHour",
    "defaultMessage": "Miles per hour"
  },
  meterPerSecond: {
    "id": "units.meterPerSecond",
    "defaultMessage": "Meters per second"
  },
  beaufort: {
    "id": "units.beaufort",
    "defaultMessage": "Beaufort"
  },
  knot: {
    "id": "units.knot",
    "defaultMessage": "Knot"
  },
  millibar: {
    "id": "units.millibar",
    "defaultMessage": "Millibar"
  },
  inchOfMercury: {
    "id": "units.inchOfMercury",
    "defaultMessage": "Inch of mercury"
  },
  millimeterOfMercury: {
    "id": "units.millimeterOfMercury",
    "defaultMessage": "Millimeter of mercury"
  },
  today: {
    "id": "units.today",
    "defaultMessage": "Today"
  },
  lastHour: {
    "id": "units.lastHour",
    "defaultMessage": "Last Hour"
  },
  lastMeasure: {
    "id": "units.lastMeasure",
    "defaultMessage": "Last measure"
  },
  co2: {
    "id": "units.co2",
    "defaultMessage": "CO2"
  },
  noise: {
    "id": "units.noise",
    "defaultMessage": "Noise"
  },
  N: {
    "id": "units.N",
    "defaultMessage": "N"
  },
  NNE: {
    "id": "units.NNE",
    "defaultMessage": "NNE"
  },
  NE: {
    "id": "units.NE",
    "defaultMessage": "NE"
  },
  ENE: {
    "id": "units.ENE",
    "defaultMessage": "ENE"
  },
  E: {
    "id": "units.E",
    "defaultMessage": "E"
  },
  ESE: {
    "id": "units.ESE",
    "defaultMessage": "ESE"
  },
  SE: {
    "id": "units.SE",
    "defaultMessage": "SE"
  },
  SSE: {
    "id": "units.SSE",
    "defaultMessage": "SSE"
  },
  S: {
    "id": "units.S",
    "defaultMessage": "S"
  },
  SSW: {
    "id": "units.SSW",
    "defaultMessage": "SSW"
  },
  SW: {
    "id": "units.SW",
    "defaultMessage": "SW"
  },
  WSW: {
    "id": "units.WSW",
    "defaultMessage": "WSW"
  },
  W: {
    "id": "units.W",
    "defaultMessage": "W"
  },
  WNW: {
    "id": "units.WNW",
    "defaultMessage": "WNW"
  },
  NW: {
    "id": "units.NW",
    "defaultMessage": "NW"
  },
  NNW: {
    "id": "units.NNW",
    "defaultMessage": "NNW"
  },
  N_long: {
    "id": "units.N_long",
    "defaultMessage": "North"
  },
  NNE_long: {
    "id": "units.NNE_long",
    "defaultMessage": "North-Northeast"
  },
  NE_long: {
    "id": "units.NE_long",
    "defaultMessage": "Northeast"
  },
  ENE_long: {
    "id": "units.ENE_long",
    "defaultMessage": "East-Northeast"
  },
  E_long: {
    "id": "units.E_long",
    "defaultMessage": "East"
  },
  ESE_long: {
    "id": "units.ESE_long",
    "defaultMessage": "East-Southeast"
  },
  SE_long: {
    "id": "units.SE_long",
    "defaultMessage": "Southeast"
  },
  SSE_long: {
    "id": "units.SSE_long",
    "defaultMessage": "South-Southeast"
  },
  S_long: {
    "id": "units.S_long",
    "defaultMessage": "South"
  },
  SSW_long: {
    "id": "units.SSW_long",
    "defaultMessage": "South-Southwest"
  },
  SW_long: {
    "id": "units.SW_long",
    "defaultMessage": "Southwest"
  },
  WSW_long: {
    "id": "units.WSW_long",
    "defaultMessage": "West-Southwest"
  },
  W_long: {
    "id": "units.W_long",
    "defaultMessage": "West"
  },
  WNW_long: {
    "id": "units.WNW_long",
    "defaultMessage": "West-Northwest"
  },
  NW_long: {
    "id": "units.NW_long",
    "defaultMessage": "Northwest"
  },
  NNW_long: {
    "id": "units.NNW_long",
    "defaultMessage": "North-Northwest"
  },
  upTrend: {
    "id": "units.upTrend",
    "defaultMessage": "up"
  },
  downTrend: {
    "id": "units.downTrend",
    "defaultMessage": "down"
  },
  stableTrend: {
    "id": "units.stableTrend",
    "defaultMessage": "stable"
  },
  min: {
    "id": "units.min",
    "defaultMessage": "Min."
  },
  avg: {
    "id": "units.avg",
    "defaultMessage": "Avg."
  },
  max: {
    "id": "units.max",
    "defaultMessage": "Max."
  },
  sum: {
    "id": "units.sum",
    "defaultMessage": "Sum"
  },
  max_wind: {
    "id": "units.max_wind",
    "defaultMessage": "Max. wind"
  },
  max_gust: {
    "id": "units.max_gust",
    "defaultMessage": "Max. gust"
  },
  humidex: {
    "id": "units.humidex",
    "defaultMessage": "Humidex"
  },
  heatIndex: {
    "id": "units.heatIndex",
    "defaultMessage": "Heat index"
  },
  autralianFormula: {
    "id": "units.autralianFormula",
    "defaultMessage": "Australian apparent temperature"
  },
  windChill: {
    "id": "units.windChill",
    "defaultMessage": "Wind chill"
  },
  setPoint: {
    "id": "units.setPoint",
    "defaultMessage": "Setpoint"
  },
  boilerOn: {
    "id": "units.boilerOn",
    "defaultMessage": "Boiler ON"
  },
  heatingPower: {
    "id": "units.heatingPower",
    "defaultMessage": "Heating power"
  },
  heatingDegreeDays: {
    "id": "units.heatingDegreeDays",
    "defaultMessage": "Heating degree days"
  },
  coolingDegreeDays: {
    "id": "units.coolingDegreeDays",
    "defaultMessage": "Cooling degree days"
  },
  degreeDay: {
    "id": "units.degreeDay",
    "defaultMessage": "Degree day"
  },
  degreeDayShort: {
    "id": "units.degreeDayShort",
    "defaultMessage": "DD"
  },
  dailyHeatingDuration: {
    "id": "units.dailyHeatingDuration",
    "defaultMessage": "Daily heating duration"
  },
  normalizedHeatingCoefficient: {
    "id": "units.normalizedHeatingCoefficient",
    "defaultMessage": "Normalized heating coefficient"
  },
  referenceTemperature: {
    "id": "units.referenceTemperature",
    "defaultMessage": "Reference temperature"
  },
  distance: {
    "id": "units.distance",
    "defaultMessage": "Distance"
  },
  meterKilometer: {
    "id": "units.meterKilometer",
    "defaultMessage": "Meter, kilometer"
  },
  footMile: {
    "id": "units.footMile",
    "defaultMessage": "Foot, mile"
  },
  solarRadiation: {
    "id": "units.solarRadiation",
    "defaultMessage": "Solar radiation"
  },
  uv: {
    "id": "units.uv",
    "defaultMessage": "UV"
  },
  wetBulbTemperature: {
    "id": "units.wetBulbTemperature",
    "defaultMessage": "Wet bulb temp."
  },
  visibility: {
    "id": "units.visibility",
    "defaultMessage": "Visibility"
  },
  AQI: {
    "id": "units.AQI",
    "defaultMessage": "AQI"
  },
  lastLightningImpact: {
    "id": "units.lastLightningImpact",
    "defaultMessage": "Last impact"
  },
  lightningDistance: {
    "id": "units.lightningDistance",
    "defaultMessage": "Distance"
  },
  lightningStrikeCount: {
    "id": "units.lightningStrikeCount",
    "defaultMessage": "Lightning strike count"
  },
  lightningStrikeDistance: {
    "id": "units.lightningStrikeDistance",
    "defaultMessage": "Lightning strike distance"
  },
  PM_1: {
    "id": "units.PM_1",
    "defaultMessage": "PM1"
  },
  PM_10: {
    "id": "units.PM_10",
    "defaultMessage": "PM10"
  },
  PM_2P5: {
    "id": "units.PM_2P5",
    "defaultMessage": "PM2.5"
  },
  O3: {
    "id": "units.O3",
    "defaultMessage": "Ozone"
  },
  solarEnergy: {
    "id": "units.solarEnergy",
    "defaultMessage": "Solar energy"
  },
  ET: {
    "id": "units.ET",
    "defaultMessage": "Evapotranspiration"
  },
  ETshort: {
    "id": "units.ETshort",
    "defaultMessage": "ET"
  },
  soilSensors: {
    "id": "units.soilSensors",
    "defaultMessage": "Soil sensors"
  },
  soilMoisture: {
    "id": "units.soilMoisture",
    "defaultMessage": "Moisture"
  },
  leafSensors: {
    "id": "units.leafSensors",
    "defaultMessage": "Leaf sensors"
  },
  leafWetness: {
    "id": "units.leafWetness",
    "defaultMessage": "Leaf wetness"
  },
  temperatureSensors: {
    "id": "units.temperatureSensors",
    "defaultMessage": "Temperature sensors"
  },
  temperatureAndHumiditySensors: {
    "id": "units.temperatureAndHumiditySensors",
    "defaultMessage": "Temperature & humidity sensors"
  },
  wetBulbGlobeTemperature: {
    "id": "units.wetBulbGlobeTemperature",
    "defaultMessage": "Web bulb globe temp."
  }
});